import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './LivestreamBadge.scss';
import messages from '../CourseDetailsHeader/coursedetailsHeaderMessages';
import formatLivestreamDate, {
  isSameDay,
} from '../../../helpers/formatLivestreamDate';

const LivestreamBadge = ({ course, streamingNow, ...rest }) => {
  if (course.type !== 'livestream') {
    return null;
  }

  return (
    <div {...rest}>
      {streamingNow && (
        <div className={s.livestreamStartBadge}>
          <FormattedMessage {...messages.streaming} />
        </div>
      )}
      {!streamingNow && (
        <div className={s.livestreamStartBadge}>
          {isSameDay(course.liveStreamStart, course.liveStreamEnd) &&
          moment().isAfter(course.liveStreamEnd) ? (
            <span>{formatLivestreamDate(course.liveStreamStart)}</span>
          ) : (
            <FormattedMessage
              {...messages.streamingStartAt}
              values={formatLivestreamDate(
                course.liveStreamStart,
                course.liveStreamEnd,
                moment().isAfter(course.liveStreamEnd),
              )}
            />
          )}
        </div>
      )}
    </div>
  );
};

LivestreamBadge.propTypes = {
  streamingNow: PropTypes.bool,
  course: PropTypes.shape({
    type: PropTypes.string,
    liveStreamStart: PropTypes.string,
    liveStreamEnd: PropTypes.string,
  }).isRequired,
};

LivestreamBadge.defaultProps = {
  streamingNow: false,
};

export default withStyles(s)(LivestreamBadge);
